import { cn } from '@/lib/utils'
import type { LeadStage } from '@limo/shared'

interface LeadStageBadgeProps {
  stage: LeadStage | { name: string; color: string }
  className?: string
}

/**
 * Helper to determine if a color is light or dark
 * Returns true if the color is light (should use dark text)
 */
function isLightColor(hexColor: string): boolean {
  // Remove # if present
  const hex = hexColor.replace('#', '')
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)
  // Calculate relative luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255
  return luminance > 0.5
}

export function LeadStageBadge({ stage, className }: LeadStageBadgeProps) {
  const isLight = isLightColor(stage.color)

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium',
        className
      )}
      style={{
        backgroundColor: `${stage.color}20`, // 20 is ~12% opacity in hex
        color: stage.color,
        borderWidth: '1px',
        borderColor: `${stage.color}40`, // 40 is ~25% opacity
      }}
    >
      <span
        className="h-2 w-2 rounded-full"
        style={{ backgroundColor: stage.color }}
        aria-hidden="true"
      />
      {stage.name}
    </span>
  )
}
